/**
 * Used to configure which sessions will be recorded in Hotjar.
 */
export const RECORD_SESSION_HOTJAR = 'RECORD_SESSION_HOTJAR';
